import {LoanApplicationInteractor} from '../../interactors/loan-application.interactor';
import {UserInteractor} from '../../interactors/user.interactor';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {LivelihoodInformationInteractor} from '../../interactors/livelihood-information.interactor';
import {UserAddressInteractor} from '../../interactors/user-address.interactor';
import {BankAccountInteractor} from '../../interactors/bank-account.interactor';
import {BorrowedInfoInteractor} from '../../interactors/borrowed-info.interactor';
import {Summary} from '../../model/summary.model';

@Injectable()
export class BorrowerSummaryResolver implements Resolve<Summary> {
    constructor(private userInteractor: UserInteractor, private loanApplicationInteractor: LoanApplicationInteractor,
                private livelihoodInformationInteractor: LivelihoodInformationInteractor,
                private bankAccountInteractor: BankAccountInteractor, private userAddressInteractor: UserAddressInteractor, private borrowedInfoInteractor: BorrowedInfoInteractor) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Summary> {
        const user = await this.userInteractor.get();
        const loanApplication = await this.loanApplicationInteractor.get();
        const livelihoodInformation = await this.livelihoodInformationInteractor.getByLoanApplicationId(loanApplication.id);
        const bankAccount = await this.bankAccountInteractor.get(loanApplication.bankAccountId);
        const userAddress = await this.userAddressInteractor.get(loanApplication.addressId);
        const borrowedInfo = await this.borrowedInfoInteractor.getByLoanApplicationId(loanApplication.id);
        return new Summary(user, bankAccount, userAddress, loanApplication, livelihoodInformation, borrowedInfo);
    }
}